import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class RiverSpring2TerrainTileEntity extends TileEntity {
	public static readonly frameName = FrameName.RIVER_SPRING2;
}

export default RiverSpring2TerrainTileEntity;
